import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { UpdatePipelineInput } from '@/gql/graphql';
import { createDraftPipelineMutation } from './createDraftPipelineMutation';
import draftMutationKeys from './keyFactory';
import { applyOptimisticUpdatePipeline } from './optimisticUpdates';

const UPDATE_PIPELINE_MUTATION = graphql(`
  mutation UpdatePipeline($input: UpdatePipelineInput!) {
    updatePipeline(input: $input) {
      id
      title
      colour
    }
  }
`);

const useDraftUpdatePipeline = createDraftPipelineMutation()({
  mutationKey: draftMutationKeys.updatePipeline,
  mutationFn: (input: UpdatePipelineInput) => {
    return gqlClient.request(UPDATE_PIPELINE_MUTATION, { input });
  },
  applyOptimisticUpdate: (data, variables) =>
    applyOptimisticUpdatePipeline(data, variables),
  squash: {
    entityId: (v) => v.id,
    merge: (older, newer) => ({ ...older, ...newer }),
  },
});

export default useDraftUpdatePipeline;
